export default __webpack_public_path__ + "static/media/icons8-amazon-web-services.73734996.svg";